const KILOBYTE = 1024;

/**
 * Human-readable size, coarsened to the largest unit that keeps the figure under 1024 — octets,
 * kilo-octets, méga-octets, giga-octets.
 */
const formatByteSize = (byteSize: number): string => {
	if (byteSize < KILOBYTE) {
		return `${byteSize} o`;
	}

	if (byteSize < KILOBYTE ** 2) {
		return `${(byteSize / KILOBYTE).toFixed(1)} Ko`;
	}

	if (byteSize < KILOBYTE ** 3) {
		return `${(byteSize / KILOBYTE ** 2).toFixed(1)} Mo`;
	}

	return `${(byteSize / KILOBYTE ** 3).toFixed(1)} Go`;
};

export default formatByteSize;
